import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store";
import {
  addMessage,
  chatContact, chatLoading, fetchMessages, getMessages, sendLoading, setContact
} from "../../store/slices/chat";
import useCurrentUser from "../../hooks/useCurrentUser";
import { MessageType } from "../../types/chat";
import { UserDataType } from "../../types/user";
import useNotifications from "../../hooks/useNotifications";
import useDoctorPatients from "../../hooks/useDoctorPatients";

const useChat = () => {
  const { state } = useLocation();
  const isChatLoading = useAppSelector(chatLoading) as boolean;
  const messages: MessageType[] = useAppSelector(getMessages);
  const contact: string | null = useAppSelector(chatContact);
  const isSendLoading: boolean = useAppSelector(sendLoading);
  const dispatch = useAppDispatch();
  const { fetchPatients } = useDoctorPatients();
  const { fetchNotifications } = useNotifications();
  const sendMessage = (content: string) => dispatch(addMessage(content));
  const { data, isDoctor } = useCurrentUser();

  const getContact = (userData: UserDataType) => {
    if (isDoctor) {
      return userData.patients?.at(-1)?.id;
    }

    return userData.oncologist?.length
      ? userData.oncologist.at(-1).id : userData.nutrizionist?.at(-1).id;
  };

  const isUserMessage = (senderId: number) => senderId === +data.id;

  useEffect(() => {
    if (state && "id" in state) {
      dispatch(setContact({ id: state.id }));
    }
  }, [state]);

  useEffect(() => {
    if (contact) {
      dispatch(fetchMessages()).then(() => {
        if (isDoctor) {
          setTimeout(() => {
            fetchNotifications();
            fetchPatients();
          }, 3000);
        }
      });
    }

    if (!contact && !state) {
      dispatch(setContact({ id: getContact(data) }));
    }
  }, [contact, state]);

  return {
    contact,
    isChatLoading,
    isSendLoading,
    messages,
    sendMessage,
    isUserMessage
  };
};

export default useChat;
